import { makeStyles } from '@material-ui/core/styles';
import { darken, lighten, alpha } from '@material-ui/core/styles/colorManipulator';

export const useStyles = makeStyles((theme) => {
    const isLightTheme = theme.palette.type === 'light';
    const hoverColor = isLightTheme
        ? darken(alpha(theme.palette.background.paper, 1), 0.03)
        : lighten(alpha(theme.palette.background.paper, 1), 0.06);

    return {
        actions: {
            ...theme.mixins.flex.displayInlineFlex,
            ...theme.mixins.flex.alignItemsCenter,
            ...theme.mixins.flex.flexWrapNowrap,
            ...theme.mixins.flex.justifyContentFlexEnd,
            ...theme.mixins.flex.grow(1),

            '& .MuiButton-text, .MuiButton-root': {
                marginLeft: theme.spacing(1.5),
            },

            '& .MuiIconButton-root': {
                '&.Mui-disabled': {
                    '& svg': {
                        fill: theme.palette.grey[400],
                    },
                },

                '&:hover': {
                    background: 'none',
                },
            },

            // Some buttons will be rendered as an <a> tag, do not
            // mess with those...
            '& a:not(.MuiButton-root)': {
                color: theme.palette.grey[600],

                '&:hover': {
                    color: theme.palette.grey[500],
                    textDecoration: 'none',
                },
            },

            '& svg': {
                '&:hover': {
                    fill: 'currentColor',
                },
            },

            '&.compact': {
                '& .MuiIconButton-root': {
                    padding: theme.spacing(0.5),
                },

                '& $actionSpacer': {
                    width: 32,
                    height: 32,
                },
            },

            '@media print': {
                display: 'none',
            },
        },
        activeAction: {
            '& svg': {
                fill: 'currentColor',
            },
        },
        actionMenu: {
            '& .MuiListItem-root': {
                cursor: 'pointer',

                '&:hover': {
                    backgroundColor: hoverColor,
                },
            },

            '& .MuiListItemIcon-root': {
                minWidth: 'unset',
                paddingRight: theme.spacing(2),
            },
        },
        actionSpacer: {
            width: 48,
            height: 48,
        },
    };
});

export default useStyles;
